import script from "./FormCustomersGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCustomersGroup.vue?vue&type=script&setup=true&lang=js"

import "./FormCustomersGroup.vue?vue&type=style&index=0&id=135f80cc&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\68\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-135f80cc"]])

export default __exports__